import { StyledTabs } from '@swarm/ui/presentational/StyledTabs'
import StyledTab from '@swarm/ui/swarm/StyledTab'
import { useTranslation } from 'react-i18next'
import { useHistory, useParams } from 'react-router'

const categories = {
  'rwa-leaderboard': 0,
  'my-stakes': 1,
}

const tabs: Array<keyof typeof categories> = ['rwa-leaderboard', 'my-stakes']

const StakingSubheader = () => {
  const { t } = useTranslation('staking')
  const history = useHistory()
  const { category = 'rwa-leaderboard' } = useParams<{
    category?: keyof typeof categories
  }>()

  const switchTab = (tab: keyof typeof categories) => {
    if (tab === tabs[0]) {
      history.push(`/staking`)
    } else {
      history.push(`/staking/${tab}`)
    }
  }

  const handleSwitchTab = (_: unknown, index: number) => {
    if (index !== categories[category]) {
      switchTab(tabs[index])
    }
  }

  return (
    <StyledTabs
      value={categories[category]}
      onChange={handleSwitchTab}
      aria-label="Invest tabs"
    >
      <StyledTab
        label={t('tabs.rwaLeaderboard')}
        value={categories['rwa-leaderboard']}
      />
      <StyledTab label={t('tabs.myStakes')} value={categories['my-stakes']} />
    </StyledTabs>
  )
}

export default StakingSubheader
